import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  search: { id: 'Search', defaultMessage: 'Buscar' },
  placeholder: { id: 'Search Site', defaultMessage: 'Buscar no site' },
});

const SearchWidget = () => {
  const intl = useIntl();
  const history = useHistory();
  const [expanded, setExpanded] = useState(false);
  const [q, setQ] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (expanded && inputRef.current) inputRef.current.focus();
  }, [expanded]);

  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    history.push(`/search?SearchableText=${encodeURIComponent(q.trim())}`);
    setExpanded(false);
    setQ('');
  };

  return (
    <div className={`ag-search ${expanded ? 'ag-search--expanded' : ''}`}>
      {!expanded ? (
        <button
          type="button"
          className="ag-search__trigger"
          onClick={() => setExpanded(true)}
          aria-label={intl.formatMessage(messages.search)}
          title={intl.formatMessage(messages.search)}
        >
          <svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="7" />
            <line x1="20" y1="20" x2="16.65" y2="16.65" />
          </svg>
        </button>
      ) : (
        <form className="ag-search__form" onSubmit={submit} role="search">
          <input
            ref={inputRef}
            type="search"
            name="SearchableText"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onBlur={() => { if (!q) setExpanded(false); }}
            onKeyDown={(e) => { if (e.key === 'Escape') { setExpanded(false); setQ(''); } }}
            placeholder={intl.formatMessage(messages.placeholder)}
            aria-label={intl.formatMessage(messages.placeholder)}
          />
          <button type="submit" aria-label={intl.formatMessage(messages.search)}>
            <svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="7" />
              <line x1="20" y1="20" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </form>
      )}
    </div>
  );
};

export default SearchWidget;
